import { render, staticRenderFns } from "./manage-country-modal.vue?vue&type=template&id=5d575b8c&scoped=true&"
import script from "./manage-country-modal.vue?vue&type=script&lang=js&"
export * from "./manage-country-modal.vue?vue&type=script&lang=js&"
import style0 from "./manage-country-modal.vue?vue&type=style&index=0&id=5d575b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d575b8c",
  null
  
)

export default component.exports